import NBType, { InferType } from '@netbase/nb-type'

const AuthRoleSchema = NBType.object().shape('AuthRoleSchema', {
  /* @prop */
  description: NBType.string(),
  /* @prop */
  name: NBType.string(),
  /* @prop */
  roleId: NBType.number()
  /* END */
})
export default AuthRoleSchema
export type AuthRole = InferType<typeof AuthRoleSchema>
// RESERVE BELOW
